<template>
  <div class="navbar-container d-flex content align-items-center">
    <!-- Nav Menu Toggler -->
    <!-- <ul class="nav navbar-nav d-xl-none">
      <li class="nav-item">
        <b-link class="nav-link" @click="toggleVerticalMenuActive">
          <feather-icon icon="MenuIcon" size="21" />
        </b-link>
      </li>
    </ul> -->

    <!-- Left Col -->
    <div class="bookmark-wrapper align-items-center d-none d-lg-flex">
      <dark-Toggler class="d-none d-lg-block" />
    </div>

    <!-- <div class="align-items-center flex-grow-1">
      <b-nav fill>
        <b-nav-item active to="/">Overview</b-nav-item>
        <b-nav-item
          to="/creative-groups"
          v-if="hasReadPermission('creative-groups')"
        >
          Creative Groups
        </b-nav-item>
        <b-nav-item
          to="/custom-targets"
          v-if="hasReadPermission('custom-targets')"
        >
          Targets
        </b-nav-item>
        <b-nav-item 
          to="/tracking"
          v-if="hasReadPermission('tracking')"
        >
          Tracking
        </b-nav-item>
        // <b-nav-item v-if="hasReadPermission('report')" @click="preparingMenu">
        <b-nav-item 
          to="/report"
          v-if="hasReadPermission('report')">
          Report
        </b-nav-item>
        <b-nav-item
          v-if="hasReadPermission('analytics')"
          @click="preparingMenu"
          style="display:none;"
        >
          Analytics
        </b-nav-item>
      </b-nav>
    </div> -->

    <b-navbar-nav class="nav align-items-center ml-auto">
      <b-nav-item-dropdown
        right
        toggle-class="d-flex align-items-center dropdown-user-link"
        class="dropdown-user"
        ref="dropdown-user"
      >
        <template #button-content>
          <b-avatar
            size="30"
            variant="light-primary"
            badge
            :src="require('@/assets/images/avatars/user-small.png')"
            class="badge-minimal mr-1"
            badge-variant="success"
          />
          <div class="d-sm-flex d-none user-nav">
            <p class="user-name font-weight-bolder mb-0">{{ userData.name }}</p>
            <span class="user-status">{{ userData.username }}</span>
          </div>
        </template>
        <b-dropdown-form>
          <b-row class="d-flex align-items-center">
            <b-col cols="3">
              <b-avatar
                size="40"
                variant="light-primary"
                badge
                :src="require('@/assets/images/avatars/user-small.png')"
                class="badge-minimal"
                badge-variant="success"
              />
            </b-col>
            <b-col cols="7">
              <p class="user-name font-weight-bolder mb-0">
                {{ userData.name }}
              </p>
              <small>{{ userData.username }}</small>
            </b-col>
            <b-col cols="2">
              <feather-icon
                class="cursor-pointer"
                @click="openMyInfo"
                icon="EditIcon"
              />
            </b-col>
          </b-row>
        </b-dropdown-form>

        <b-dropdown-divider />
        <b-dropdown-form>
          <b-row class="d-flex align-items-center">
            <b-col cols="6">
              <b-button
                variant="outline-primary"
                class="full-width"
                @click="openSetting"
                disabled
              >
                <span class="align-middle">Setting</span>
              </b-button>
            </b-col>
            <b-col cols="6">
              <b-button
                variant="outline-primary"
                class="full-width"
                @click="logout"
              >
                <span class="align-middle">Logout</span>
              </b-button>
            </b-col>
          </b-row>
        </b-dropdown-form>
      </b-nav-item-dropdown>
    </b-navbar-nav>
    <my-info />
  </div>
</template>

<script>
import {
  BLink,
  BNav,
  BNavItem,
  BNavbarNav,
  BNavItemDropdown,
  BDropdownItem,
  BDropdownDivider,
  BAvatar,
  BDropdownForm,
  BRow,
  BCol,
  BButton,
} from "bootstrap-vue";
import DarkToggler from "@core/layouts/components/app-navbar/components/DarkToggler.vue";
import useJwt from "@/auth/jwt/useJwt";
import MyInfo from "@/views/settings/modal/MyInfo";
import ToastificationContent from "@core/components/toastification/ToastificationContent";

import AuthenticationService from "@/services/authentication.service";

export default {
  components: {
    MyInfo,
    BLink,
    BNav,
    BNavItem,
    BNavbarNav,
    BNavItemDropdown,
    BDropdownItem,
    BDropdownDivider,
    BAvatar,
    BDropdownForm,
    BRow,
    BCol,
    BButton,
    // Navbar Components
    DarkToggler,
  },
  props: {
    toggleVerticalMenuActive: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      userData: useJwt.getUserData(),
    };
  },
  methods: {
    openMyInfo() {
      this.popupKey = Math.floor(Math.random() * 100);
      this.$nextTick(() => {
        this.$bvModal.show("my-info-modal");
      });
    },
    openSetting() {
      this.$refs["dropdown-user"].hide();
      this.$router.push({ name: "account-info" }).catch(() => {});
    },
    async logout() {
      await AuthenticationService.logout();
      useJwt.logout();
      // redirect to login page
      this.$router.push({ name: "login" });
    },
    preparingMenu() {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: `Coming soon!`,
          icon: "EditIcon",
          variant: "success",
        },
      });
    },
  },
  mounted() {
    this.$root.$on("set-login-info", () => {
      this.userData = useJwt.getUserData();
    });
  },
};
</script>

<style>
.header-navbar .navbar-container ul.navbar-nav li.dropdown-user .dropdown-menu {
  min-width: 300px;
}
</style>
